import React, { useState } from 'react';
import { termsTemplateOptions } from '../../../utils/termsTemplates';

const TermsSettingsStep = ({ data, onChange }) => {
  const [selectedTemplates, setSelectedTemplates] = useState({});
  
  const fields = [
    { key: 'salesTerms', title: 'Sales Terms & Conditions', icon: '💰' },
    { key: 'purchaseTerms', title: 'Purchase Terms & Conditions', icon: '🛒' },
    { key: 'quotationTerms', title: 'Quotation Terms & Conditions', icon: '📋' },
    { key: 'footer', title: 'Document Footer', icon: '📄' }
  ];

  const templateTypes = [
    { key: 'singleLiner', label: 'Single Liner', icon: '📝', color: 'bg-blue-100 text-blue-800' },
    { key: 'smallPara', label: 'Small Para', icon: '📄', color: 'bg-green-100 text-green-800' },
    { key: 'mediumPointer', label: 'Medium Pointer', icon: '📋', color: 'bg-yellow-100 text-yellow-800' },
    { key: 'professional', label: 'Professional', icon: '🏢', color: 'bg-purple-100 text-purple-800' }
  ];

  const handleTemplateSelect = (field, templateType) => {
    setSelectedTemplates({ ...selectedTemplates, [field]: templateType });
    const template = termsTemplateOptions[field][templateType];
    onChange(field, template);
  };

  const handleTemplatePreview = (field, templateType) => {
    setSelectedTemplates({ ...selectedTemplates, [field]: templateType });
  };

  const getCurrentTemplate = (field) => {
    return selectedTemplates[field] || 'professional';
  };

  return (
    <div className="space-y-6">
      <div className="text-center mb-6">
        <h3 className="text-2xl font-bold text-gray-900 mb-1">Terms & Conditions</h3>
        <p className="text-gray-600">Set up your business terms and conditions for different document types</p>
      </div>

      <div className="space-y-6">
        {fields.map(({ key, title, icon }) => (
          <div key={key} className="bg-white border border-gray-200 rounded-lg p-6">
            <h4 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
              <span className="text-2xl mr-3">{icon}</span>
              {title}
            </h4>
            
            {/* Template Selection Buttons */}
            <div className="mb-4">
              <p className="text-sm font-medium text-gray-700 mb-3">Choose Template Type:</p>
              <div className="flex flex-wrap gap-2">
                {templateTypes.map((template) => (
                  <button
                    key={template.key}
                    onClick={() => handleTemplateSelect(key, template.key)}
                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                      getCurrentTemplate(key) === template.key
                        ? template.color + ' ring-2 ring-offset-2 ring-blue-500'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                  >
                    <span className="mr-2">{template.icon}</span>
                    {template.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Preview Selected Template */}
            <div className="mb-4">
              <p className="text-sm font-medium text-gray-700 mb-2">Preview Selected Template:</p>
              <div className="bg-gray-50 border border-gray-200 rounded-lg p-3 max-h-32 overflow-y-auto">
                <pre className="text-sm text-gray-600 whitespace-pre-wrap">
                  {termsTemplateOptions[key][getCurrentTemplate(key)]}
                </pre>
              </div>
            </div>
            
            {/* Text Area for Editing */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Edit Terms & Conditions:
              </label>
              <textarea
                rows={8}
                value={data[key] || termsTemplateOptions[key][getCurrentTemplate(key)] || ''}
                onChange={(e) => onChange(key, e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-y"
                placeholder={`Type your ${title.toLowerCase()}...`}
                style={{ 
                  minHeight: '200px', 
                  lineHeight: '1.6'
                }}
              />
              
              <div className="mt-2 text-right text-sm text-gray-500">
                {(data[key] || termsTemplateOptions[key][getCurrentTemplate(key)] || '').length} characters
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TermsSettingsStep;